export const isRegisterSinister = () =>
  window.location.search.includes('register_sinister');
